import { MdDeleteOutline } from "react-icons/md";
import { useNavigate } from "react-router-dom";

// Define the types for the component props
interface DetailCardProps {
  ImageUrl?: string;
  Name?: string;
  Position?: string;
  Description?: string;
  HandleDelete?: (testimonialId: string) => void;
  HandleEdit?: () => void;
}

export default function DetailCard({
  ImageUrl = "https://www.shutterstock.com/image-photo/happy-black-man-mature-portrait-260nw-2281799533.jpg",
  Name = "Kyra Smith",
  Position = "Head of Finance",
  Description = "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable.",
  HandleDelete,
  HandleEdit,
}: DetailCardProps) {
  const navigate = useNavigate();

  // Handle delete click event
  const handleDeleteClick = () => {
    if (HandleDelete) {
      HandleDelete(Name);  // Assuming 'Name' is unique to identify the testimonial
    } else {
      navigate("/");
    }
  };

  return (
    <div className="bg-white p-4 rounded border flex items-start space-x-4 group">
      <img
        className="w-[40px] h-[40px] bg-[#D9D9D9] mt-1 rounded-full object-center object-cover"
        src={ImageUrl}
        alt="profile-img"
      />

      <div className="w-full">
        <div className="flex items-center space-x-2">
          <p className="w-full capitalize font-[600]">{Name}</p>
          <MdDeleteOutline
            onClick={handleDeleteClick}
            className="text-[22px] text-red-500/[.0] group-hover:text-red-500 hover:cursor-pointer duration-300"
          />
        </div>

        <p className="text-black/default capitalize font-[600]">{Position}</p>

        <p className="text-black/default">{Description}</p>
      </div>
    </div>
  );
}
